<!-- As a link -->
<header class="sticky fixed-top">
  @if(showHeader){
  <div class="row pb-0">
    <!-- <nav class="navbar navbar-expand-lg shadow-sm pt-1 pb-0 theme_bg"> -->
    <nav class="navbar navbar-expand-lg shadow-sm pt-1 pb-0 user-header-nav" [ngStyle]="{'background-color': theme_color}">
      <a class="navbar-brand" href="javascript:void(0)"><img class="navbar-logo" imageLoad="logo" [src]="profile" />
        <!-- <span
          style="color: white;">{{title}}</span> -->
      </a>
      <div class="navbar-collapse d-sm-none user-header-content">

        <div class="input-group user-header-search">
          <!-- <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" style="border-radius: 2rem 0rem 0rem 2rem;background-color: white;color:#A00000"></button>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" href="#">Patient</a></li>
            <li><a class="dropdown-item" href="#">Invoice</a></li>
  
          </ul> -->
          <div class="search-type">
            <select [formControl]="searchDropDown" class="form-control searchdropdown form-select theme"
              [ngStyle]="{'color':theme_color}">
              <option value="Patient">Patient</option>
              <option value="Invoice">Invoice</option>
              <!-- <option value="Treatment">Treatment</option> -->

            </select>
          </div>
          <!-- <div class="card flex justify-content-center">
            <p-dialog header="Header" [(visible)]="showPanel" [style]="{ width: '50vw' }">
              <div class="flex py-2 justify-content-center">
              </div>
            </p-dialog>
          </div> -->

          <p-overlay #opSearch [(visible)]="showPanel"
            [responsive]="{ breakpoint: '640px', direction: 'bottom', contentStyleClass: 'h-20rem' }"
            contentStyleClass=" surface-overlay shadow-2 border-round w-100">
            <div class="dropdownInput shadow-lg p-3 mb-5 bg-white rounded">
              <div class="dropdown-result">
                <div class="table-responsive ">
                  <table class="table table-hover spacing8">
                    <tbody>
                      <ng-container *ngIf="resultData.length else noRecordSearch">
                        <tr *ngFor="let a of resultData" class="cursor-pointer w-100" (click)="selectSearch(a.id)">
                          <td>{{a?.patient_id || a?.invoice_id || a?.receipt_id}}</td>
                          <td>{{a?.f_name ||a?.patient_fullName}} {{a?.l_name}}</td>
                          <td>{{a?.total_amount || a?.mobile_no}}</td>
                          <td>{{a?.address || a?.statusName}}</td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </p-overlay>
          <ng-template #noRecordSearch>
            <tr>
              <td colspan="4">
                <h5>No Matched Data</h5>
              </td>
            </tr>
          </ng-template>
          <input autocomplete="doNotAutoComplete" type="text" [formControl]="searchControl"
            class="form-control border-0" placeholder="Search {{searchDropDown.value | titlecase}}"
            style="border-radius: 0rem 2rem 2rem 0rem;">
        </div>
        <!-- modefiy -->
        <ul class="navbar-nav user-header-profile">
          <!-- searchbar start -->
          <!-- searchbar end -->
          <!-- <li class="nav-item">
            <a class="nav-link" pTooltip="Display" tooltipPosition="left" (click)="display.toggle($event)">
              <i class="las la-tv" style="color: white;"></i>
            </a>
          </li> -->
          <!-- <p-overlayPanel #op>
            <div
              style="min-width: 15rem;min-height: 10rem;background-image: linear-gradient(to top,#feecec 10%,white 95%);">
              <header style="text-decoration: underline;">Waiting list</header>
              <app-waiting-list />
            </div>
          </p-overlayPanel> -->

          <!-- <li class="nav-item"><a class="nav-link"><i class="las la-question-circle" style="color: white;"></i></a></li> -->
          <!-- <li class="nav-item dropdown dropleft"><a class="nav-link notification-dropdown" href="javascript:void(0)"
              role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span
                class="badge badge-pill badge-primary" style="float:right;margin-bottom:-10px;"></span><i
                class="las la-bell" style="color: white;"></i></a>
            <div class="dropdown-menu notification-dropdown-menu shadow-lg" aria-labelledby="notification-dropdown">
              <div class="dropdown-title"><a href="javascript:void(0)">notifications<span
                    class="ml-2 notifications-count">(3)</span></a><a class="float-right" href="">mark
                  all as read</a></div>
              <div class="dropdown-body">
                <ul class="list-unstyled">
                  <li class="media"><a class="notification-card" href=""><img class="mr-3"
                        src="../assets/images/inbox.svg" alt="..." />
                      <div class="media-body">
                        <h6 class="mt-0 mb-1">collaboration tools available</h6>
                        <p>Cras sit amet nibh libero, in gravida nulla.</p><small class="text-muted">21.03.2020,
                          13.02</small>
                      </div>
                    </a></li>
                  <li class="media"><a class="notification-card" href=""><img class="mr-3"
                        src="../assets/images/inbox.svg" alt="..." />
                      <div class="media-body">
                        <h6 class="mt-0 mb-1">use the new app launcher</h6>
                        <p>Cras sit amet nibh libero, in gravida nulla.</p><small class="text-muted">21.03.2020,
                          13.02</small>
                      </div>
                    </a></li>
                  <li class="media"><a class="notification-card" href=""><img class="mr-3"
                        src="../assets/images/inbox.svg" alt="..." />
                      <div class="media-body">
                        <h6 class="mt-0 mb-1">the new dashboard abailable</h6>
                        <p>Cras sit amet nibh libero, in gravida nulla.</p><small class="text-muted">21.03.2020,
                          13.02</small>
                      </div>
                    </a></li>
                </ul>
              </div>
              <div class="dropdown-footer text-center"><a href="notifications.html">view more</a></div>
            </div>
          </li> -->
          <!-- <li class="nav-item">
            <div class="nav-link"><span class="vertical-divider"></span></div>
          </li> -->
          <li class="nav-item" clickOutside (clickOutside)="isMenuOpened=false">
            <a (click)="isMenuOpened = !isMenuOpened" class="nav-link profile-dropdown" href="javascript:void(0)"
              role="button">
              <img class="rounded-circle" [src]="user?.imageUrl" imageLoad />
              <span class="d" style="color: white;">{{user?.fname}}</span>
            </a>
            <div class="dropdown">
              <div class="dropdown-menu shadow-lg profile-dropdown-menu" [class.show]="isMenuOpened">
                <a class="dropdown-item" href="javascript:void(0)" style="padding-left: 8px;"
                  (click)="openUserProfile()"><i class="las la-user mr-2"></i>Profile</a>
                <a class="dropdown-item" href="javascript:void(0)" style="padding-left: 8px;"
                  (click)="openChangePassword()"><i class="las la-key mr-2"></i>Change Password</a>
                <!-- <a class="dropdown-item" href="#"><i class="las la-cog mr-2"></i>settings</a> -->
                <a class="dropdown-item" href="javascript:void(0)" style="padding-left: 8px;" (click)="logout()"><i
                    class="las la-cog mr-2"></i>Logout</a>
              </div>
            </div>
          </li>
          <!-- client need -->
          <!-- <li class="nav-item">
            <a class="nav-link" pTooltip="Display" tooltipPosition="left" (click)="display.toggle($event)">
              <i class="las la-tv" style="color: white;"></i>
            </a>
          </li> -->
        </ul>
      </div>
    </nav>

  </div>
  <!-- As a heading -->
  <div class="container-fluid pb-0 bottom-menu border-bottom bg-white">
    <nav class="bottom-nav align-items-center-0 p-0">
      <div class="container">
        <ul class="navbar-nav ml-auto mr-md-3">
          @for (m of menu; track m) {
          <li class="nav-item" [style.background-color]="currentTab == m?.urlParentPath ? theme_color : ''">
            <a href="javascript:void(0)" class="nav-link" [routerLink]="['/'+m?.link]" [attr.tittle]="m?.title"
              [queryParams]="m?.queryParams"
              [style.color]="currentTab == m?.urlParentPath ? 'white' : ''">{{m?.title}}</a>
          </li>
          }
        </ul>
      </div>
    </nav>
  </div>
  }
</header>
<p-overlayPanel #display>
  <ng-template pTemplate="content">
    <p class="text-muted font-weight-normal small">Display</p>
    <ul class="list-unstyled">
      @for (it of displayData; track $index) {
      <li class="media cursor-pointer " (click)="openDisplay(it);display.hide()">
        <div class="media-body">
          <p>{{it.counterName}}</p>
        </div>
      </li>
      }
    </ul>
  </ng-template>
</p-overlayPanel>
